export enum SliderMediaType {
  IMAGE = 'image',
  VIDEO = 'video'
}
